import React, { useEffect, useRef, useState } from "react";
import MaestroLoader from "@components/MaestroLoader";
import ErrorLoadingWidget from "./ErrorLoadingWidget";
import { LoadingWidget } from "./LoadingWidget";
import CardWidget from "./layouts/CardWidget";
import { Box, Button, ButtonGroup, CardCover, Divider, Grid, IconButton, Sheet, ToggleButtonGroup, Typography } from "@mui/joy";
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';
import RedoRoundedIcon from '@mui/icons-material/RedoRounded';
import FormatBoldRoundedIcon from '@mui/icons-material/FormatBoldRounded';
import FormatItalicRoundedIcon from '@mui/icons-material/FormatItalicRounded';
import FormatUnderlinedRoundedIcon from '@mui/icons-material/FormatUnderlinedRounded';
import FormatStrikethroughRoundedIcon from '@mui/icons-material/FormatStrikethroughRounded';
import StrikethroughSRoundedIcon from '@mui/icons-material/StrikethroughSRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import FormatIndentIncreaseRoundedIcon from '@mui/icons-material/FormatIndentIncreaseRounded';
import FormatIndentDecreaseRoundedIcon from '@mui/icons-material/FormatIndentDecreaseRounded';

// import { Color } from '@tiptap/extension-color';
import { EditorProvider, useCurrentEditor } from '@tiptap/react';
import Underline from '@tiptap/extension-underline';
import TextStyle from '@tiptap/extension-text-style';
import ListItem from '@tiptap/extension-list-item';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import { RichTextEditor } from "@components/forms/RichText/RichTextEditor";
import { useDebounce } from "@uidotdev/usehooks";

export default function NotesWidget(props) {
    const [isSyncing, setIsSyncing] = useState(false);
    const [isSynced, setIsSynced] = useState(true);
    const didMount = useRef(false);

    let initialContent = props?.widget?.options?.text ?? '';

    // fix line breaks from old maestro
    initialContent = initialContent.replaceAll('<p><br/></p>', '');

    const [content, setContent] = useState(initialContent);
    let debouncedContent = useDebounce(content, 500); // prevent saving too often

    const onChange = (value) => {
        if(!didMount.current) {
            return;
        }

        setIsSynced(false);
        setContent(value);
    };

    useEffect(() => {
        if(!didMount.current) {
            didMount.current = true;
            // console.log('will NOT update notes');
            return;
        }

        setIsSyncing(true);
        const widget = props.widget;
        widget.options.text = debouncedContent;
        props.updateWidget(widget).then(() => {
            setIsSynced(true);
            setIsSyncing(false);
        });
    }, [debouncedContent]);


    return (
        <CardWidget
            unpadded
            title="Notes"
            {...props}
            syncing={isSyncing}
            synced={isSynced}
        >
            <RichTextEditor
                initialContent={initialContent}
                onChange={onChange}
            />
        </CardWidget>
    );
}
